import { createClient, FindOperation, getRequestFactory } from '@infuse/api/common';
import { ComponentGroup } from './model';

const client = createClient('/rest/operator-api/charging-stations');

export const componentModelPermissions = {
  GET: 'cpms.get-charging-station-configuration-model'
};

export const getComponentModelForChargingStation: FindOperation<ComponentGroup> = getRequestFactory<ComponentGroup>(
  client,
  { pattern: '/{chargingStationId}/configuration', permissionId: componentModelPermissions.GET }
);
